export const routesData = {
    login: "/login",
    dashboard: "/",
    projects: "/projects",
    gantt: "/gantt",
    time: "/time",
    meetings: "/meetings",
    deliveryAnalytics: "/delivery-analytics",
    sprints: "/sprints",
    tasks: "/tasks",
    blockers: "/blockers",
    decisions: "/decisions",
    communication: "/communication",
    workload: "/workload",
    reports: "/reports",
    analytics: "/analytics",
    ownership: "/ownership",
    handoffs: "/handoffs",
    users: "/users",
    userDetail: "/users/:userId",
    teams: "/teams",
    commentsLog: "/comments-log",
    redFlags: "/red-flags",
    alerts: "/alerts",
    profile: "/profile",
    settings: "/settings",
    deploys: "/deploys",
    reminders: "/reminders",
} as const;
